import { useCallback, useEffect, useState } from 'react';
import {
  isNotificationSoundEnabled,
  NOTIFICATION_SOUND_PREF_EVENT,
  playNotificationSound,
  setNotificationSoundEnabled,
} from '../lib/notificationSound';

export function useNotificationSoundPref() {
  const [enabled, setEnabled] = useState(isNotificationSoundEnabled);

  useEffect(() => {
    const sync = () => setEnabled(isNotificationSoundEnabled());
    window.addEventListener(NOTIFICATION_SOUND_PREF_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(NOTIFICATION_SOUND_PREF_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const setSoundEnabled = useCallback((on: boolean) => {
    setNotificationSoundEnabled(on);
    setEnabled(on);
    if (on) playNotificationSound();
  }, []);

  return { soundEnabled: enabled, setSoundEnabled };
}
